export const toggleProject = () => {

    const toggleButtons = document.querySelectorAll(".js-project-toggle");

    // Handle browser back/forward navigation
    const handlePopState = (event) => {
        const currentPath = window.location.pathname;
        
        // Check if we're on a project page or projects list
        if (currentPath === '/projects' || currentPath === '/') {
            // Collapse all projects
            toggleButtons.forEach((button) => {
                const container = button.parentElement;
                container.dataset.state = "collapsed";
            });
        } else if (currentPath.startsWith('/projects/')) {
            // Extract project slug from URL (format: /projects/project-slug)
            const pathSegments = currentPath.split('/').filter(segment => segment);
            const projectSlug = pathSegments[1]; // projects/[project-slug]
            
            if (projectSlug) {
                // Find and expand the specific project
                const targetButton = document.querySelector(`[data-project="${projectSlug}"]`);
                if (targetButton) {
                    const container = targetButton.parentElement;
                    container.dataset.state = "expanded";
                    
                    // Dispatch custom event to reinitialize lightbox
                    window.dispatchEvent(new CustomEvent('project-toggled', { 
                        detail: { projectSlug, isExpanded: true } 
                    }));
                }
            }
        }
    };

    // Listen for browser navigation
    window.addEventListener('popstate', handlePopState);

    const getHeaderOffset = () => {
        const sortHeader = document.querySelector(".c-projects-list-sort");
        
        // Check if header exists and is actually sticky/visible
        if (sortHeader && getComputedStyle(sortHeader).position === 'sticky') {
            // On mobile, the header might be hidden, so check visibility
            const headerStyle = getComputedStyle(sortHeader);
            if (headerStyle.display === 'none' || sortHeader.offsetHeight === 0) {
                return 0;
            }
            
            // Use the actual height which includes the padding-top: 0.5em that was added
            // This automatically accounts for the new padding without needing separate calculation
            const headerHeight = sortHeader.offsetHeight;
            const additionalBuffer = 8; // Small additional buffer for visual spacing
            return headerHeight;
        }
        return 0;
    };

    const scrollToElementWithOffset = (element, offset) => {
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset - offset;

        // Ensure we don't scroll past the top of the page
        const finalPosition = Math.max(0, offsetPosition);

        window.scrollTo({
            top: finalPosition,
            behavior: "smooth"
        });
    };

    toggleButtons.forEach((toggleButton) => {
        toggleButton.addEventListener("click", (e) => {
            e.preventDefault();
            const projectContainer = toggleButton.parentElement;
            const isCurrentlyExpanded = projectContainer.dataset.state === "expanded";
            const newState = isCurrentlyExpanded ? "collapsed" : "expanded";
            
            // Toggle current project
            projectContainer.dataset.state = newState;
            
            // Get project slug for event
            const projectSlug = projectContainer.querySelector('.js-project-toggle')?.getAttribute('data-project') || 
                              projectContainer.querySelector('.c-projects-list__item')?.getAttribute('data-project');
            
            if (newState === "expanded") {
                // Calculate offset to account for sticky header so the project doesn't 
                // get hidden behind the fixed table header when scrolling
                const headerOffset = getHeaderOffset();
                scrollToElementWithOffset(toggleButton, headerOffset);
            }
            
            // Dispatch custom event to reinitialize lightbox
            window.dispatchEvent(new CustomEvent('project-toggled', { 
                detail: { projectSlug, isExpanded: newState === "expanded" } 
            }));
        });
    });

    
    
};
